import React, { useState } from 'react';
import Editor from '../Editor/Editor';

const EditStaffForm = ({ staffConfig, setStaffConfig, onSave }) => {
  // const [staffConfig, setStaffConfig] = useState(initialConfig);

  const handleInputChange = (e, category, index) => {
    const { name, value } = e.target;
    const updatedData = { ...staffConfig };
    updatedData[category][index][name] = value;
    setStaffConfig(updatedData); // Update local state
  };

  const handleDelete = (category, index) => {
    const updatedData = { ...staffConfig };
    updatedData[category].splice(index, 1); // Remove the staff/provider from the array
    setStaffConfig(updatedData); // Update local state
  };

  const handleSave = () => {
    onSave(staffConfig); // Save the updated configuration when the "Save Changes" button is clicked
  };

  return (
    <div className="bg-gray-700 p-6 rounded-lg"> {/* Grouping container with a background color */}
      <h1 className="text-4xl font-bold mb-4 text-white">Edit Staff Information</h1>
      {/* Providers Section */}
      <div className="bg-gray-500 p-4 rounded-lg mb-6"> {/* Providers subsection with a separate background */}
        <h2 className="text-2xl text-white font-bold mb-4">Providers</h2>
        {(staffConfig?.providers || []).map((provider, index) => (
          <div key={index} className="collapse collapse-arrow bg-base-200 mb-2">
            <input type="radio" name="my-accordion-providers" />
            <div className="collapse-title text-xl font-medium">
              {provider.name}
            </div>
            <div className="collapse-content flex items-start space-x-4">
              <img src={provider.picture} alt={provider.name} className="w-20 h-20 object-cover rounded" />
              <div className="flex flex-col flex-1 space-y-4">
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-col space-x-2">
                    <label className="font-bold">Name:</label>
                    <input
                      type="text"
                      name="name"
                      value={provider.name}
                      onChange={(e) => handleInputChange(e, 'providers', index)}
                      className="input input-bordered w-full"
                    />
                  </div>
                  <div className="flex flex-col space-x-2">
                    <label className="font-bold">Title:</label>
                    <input
                      type="text"
                      name="title"
                      value={provider.title}
                      onChange={(e) => handleInputChange(e, 'providers', index)}
                      className="input input-bordered w-full"
                    />
                  </div>
                </div>
                <div className="flex flex-col space-y-2">
                  <label className="font-bold">Bio:</label>
                  <textarea
                    name="bio"
                    value={provider.bio}
                    onChange={(e) => handleInputChange(e, 'providers', index)}
                    className="textarea textarea-bordered w-full"
                    rows="6" // Increased rows for a larger textarea
                  />
                  {/* <Editor
                    defaultValue={provider.bio}
                    editorId={`StaffForm_${index}`}
                    index={index}
                    configState={staffConfig}
                    setConfig={setStaffConfig}
                  /> */}
                  <Editor
                    editorId={`providerBio_${index}`}
                    value={provider.bio}
                    onChange={(html) =>
                      setStaffConfig((prev) => ({
                        ...prev,
                        providers: (prev.providers || []).map((p, j) =>
                          j === index ? { ...p, bio: html } : p
                        ),
                      }))
                    }
                  />
                </div>
                {/* <Editor defaultValue={provider.bio} onChange={(e) => handleInputChange(e, 'providers', index)} editorId={`StaffEditor_${index}`}/> */}
              </div>
              <button
                onClick={() => handleDelete('providers', index)}
                className="btn btn-error ml-auto"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Staff Section */}
      <div className="bg-gray-500 p-4 rounded-lg"> {/* Staff subsection with a separate background */}
        <h2 className="text-2xl text-white font-bold mb-4">Staff</h2>
        {(staffConfig?.staff || []).map((staff, index) => (
          <div key={index} className="collapse collapse-arrow bg-base-200 mb-2">
            <input type="radio" name="my-accordion-staff" />
            <div className="collapse-title text-xl font-medium">
              {staff.name}
            </div>
            <div className="collapse-content flex items-center space-x-4">
              <img src={staff.picture} alt={staff.name} className="w-20 h-20 object-cover rounded" />
              <div className="flex flex-1 space-x-4">
                <div className="flex items-center space-x-2">
                  <label className="font-bold">Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={staff.name}
                    onChange={(e) => handleInputChange(e, 'staff', index)}
                    className="input input-bordered w-full"
                  />
                </div>
                <div className="flex items-center space-x-2">
                  <label className="font-bold">Title:</label>
                  <input
                    type="text"
                    name="title"
                    value={staff.title}
                    onChange={(e) => handleInputChange(e, 'staff', index)}
                    className="input input-bordered w-full"
                  />
                </div>
              </div>
              <button
                onClick={() => handleDelete('staff', index)}
                className="btn btn-error ml-auto"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Save Changes Button */}
      <div className="mt-6 text-right">
        <button
          onClick={handleSave}
          className="btn btn-primary"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EditStaffForm;
